<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'DATE_FILTER_HELP_TITLE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p>{{ 'DATE_FILTER_HELP_TEXT' | translate }}</p>
</ion-content>